import React from 'react';
import { useParams } from 'react-router-dom';
import {
    useTranslate, useGetOne, Show, TopToolbar,
    DeleteWithConfirmButton, useNotify, useRedirect, usePermissions
} from 'react-admin';
import BasicBreadcrumbs from '../../components/breadcrumb';
import { CustomInstanceShow } from '../../custom';

const CustomDeleteButton = (props) => {
    const translate = useTranslate();
    const notify = useNotify();
    const redirect = useRedirect();
    const { permissions, isLoading } = usePermissions();

    const title = `${translate('app.vms.delete.title')} ${props.record.name}`;

    const handleSuccess = () => {
        notify(translate('app.vms.delete.successMessage'), { type: 'info' });

        // Only redirect if user has list access
        if (permissions?.includes('admin')) {
            // redirect('list', 'vms'); // or your resource name
            if (window.history.length > 1) {
                window.history.back();
            } else {
                redirect('/'); // fallback if no previous page exists
            }

        } else {
            redirect('/');
        }
    };

    return (
        <DeleteWithConfirmButton
            confirmTitle={title}
            confirmContent={translate('app.vms.delete.confirmMessage')}
            mutationOptions={{ onSuccess: handleSuccess }}
            {...props}
        />
    );
};

const Actions = (props) => {
    return (
        <TopToolbar>
            <CustomDeleteButton record={props.record} />
        </TopToolbar>
    )
};

const VmShowGeneric = ({ resourceType }) => {
    const translate = useTranslate();
    const { id, podId, vmId } = useParams();

    const { data: mainData, isLoading: isLoadingMain, error: errorMain } = useGetOne(resourceType, { id }, { enabled: resourceType !== 'myclassroom' });
    const { data: podData, isLoading: isLoadingPod, error: errorPod } = useGetOne('pods', { id: podId });
    const { data: vmData, isLoading: isLoadingVm, error: errorVm } = useGetOne('vms', { id: vmId });

    if ((isLoadingMain && resourceType !== 'myclassroom') || isLoadingPod || isLoadingVm) return <div>{translate('app.LoadingMessage')}</div>;
    if ((errorMain && resourceType !== 'myclassroom') || errorPod || errorVm) return <div>{translate('app.ErrorMessage')}</div>;

    return (
        <>
            <BasicBreadcrumbs name={resourceType !== 'myclassroom' ? mainData?.name : ''} name2={podData.name} name3={vmData.name} />
            <Show actions={<Actions record={vmData} />} id={vmId} resource="vms" redirect={false}>
                <CustomInstanceShow record={vmData} />
            </Show>
        </>
    );
};

export default VmShowGeneric;
